import Color from 'color';

interface SiteStore {
    site: {
        primaryColor: string;
        secondaryColor: string;
        sceneBackgroundColor: string;
    };
}

interface SiteColors {
    primary: string;
    secondary: string;
    card: string;
    background: string;
}

interface ColorShades {
    [key: string]: string;
}

export function updateCSSVariables(siteStore: SiteStore) {
    const root = document.documentElement;
    const colors: SiteColors = {
        primary: siteStore.site.primaryColor || '#40475B',
        secondary: siteStore.site.secondaryColor || '#FFFFFF',
        card: '#40475B',
        background: siteStore.site.sceneBackgroundColor || '#40475B'
    };

    for (const [key, color] of Object.entries(colors)) {
        const shades: ColorShades = generateShades(color);
        for (const [shade, value] of Object.entries(shades)) {
            root.style.setProperty(`--color-${key}-${shade}`, value);
        }
    }

    root.style.setProperty('--color-background', colors.background);
}

export function generateShades(baseColor: string): ColorShades {
    const color = Color(baseColor);
    const hsl = color.hsl();

    const baseLightness = hsl.color[2];
    const lighterRange = 100 - baseLightness;
    const darkerRange = baseLightness;

    const getLightShade = (step: number, totalSteps: number) =>
        Color.hsl(hsl.color[0], hsl.color[1], baseLightness + (step / totalSteps) * lighterRange).hex();

    const getDarkShade = (step: number, totalSteps: number) =>
        Color.hsl(hsl.color[0], hsl.color[1], baseLightness - (step / totalSteps) * darkerRange).hex();

    return {
        50: getLightShade(4.5, 5),
        100: getLightShade(4, 5),
        200: getLightShade(3, 5),
        300: getLightShade(2, 5),
        400: getLightShade(1, 5),
        500: baseColor,
        600: getDarkShade(1, 5),
        700: getDarkShade(2, 5),
        800: getDarkShade(3, 5),
        900: getDarkShade(4, 5),
        950: getDarkShade(4.5, 5)
    };
}
